import { useContext, useEffect } from "react";
import { ThemeContext } from "./themeContext";

export const SetThemeContext = theme => {
   const context = useContext(ThemeContext);
   useEffect(() => {
      context.setNavbarTheme(theme);
   }, [context, theme]);
};
